/** uint64 max — represents a permanent (no-expiry) delegation. */
export const MAX_UINT64 = 2n ** 64n - 1n;
